module.exports = __webpack_public_path__ + "fonts/Montserrat_Bold_Latin_Ext.86a4da42.woff2";